import {filter ,uniq} from 'lodash'
import draggable from 'vuedraggable'

export default {
  name: 'TableColumnSettings',
  components: { draggable },
  props: {
    columns: {
      type: Array,
      default: [],
      required: true
    },
    tableSettingOptions: {
      type: Array,
      default: [],
      required: true
    },
    updateColumnsInTable: {
      type: Function,
      required: true
    },
    clickedOn: {
      type: String,
      required: true
    },
    category: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      columnSettingPopup: false,
      // columns: this.columns,
      columnsToAdd: Object.assign([], this.columns),
      menu: this.tableSettingOptions
    }
  },
  methods: {
    /*
    * addOrRemoveColumn() add/remove the selected @value to an array "columnsToAdd"
    * */
    addOrRemoveColumn (isChecked, value) {
      if (isChecked) {
        this.columnsToAdd.push(value.key)
      } else {
        this.columnsToAdd = this.columnsToAdd.filter(item => item !== value.key)
      }
      this.columnsToAdd = filter(this.tableSettingOptions, (o) => uniq(this.columnsToAdd).includes(o.key)).map((o) => o.key)
    },
    onDragEnd () {
      this.columnsToAdd = filter(this.tableSettingOptions, (o) => uniq(this.columnsToAdd).includes(o.key)).map((o) => o.key)
    }
  },
  watch: {
    columns: function (newColumns) {
      this.columnsToAdd = Object.assign([], newColumns)
    }
  }
}
